<script lang="ts">
  import Price from "@retailer/svelte/Cart/Page/DistributorSection/Price.svelte";

  export let isMobile: boolean;
  export let total: any;
  export let products: any;
  export let accordionOpenByDefault: boolean;
  export let onClick: (eventType: string) => void;

  let isOpen: boolean = accordionOpenByDefault;

  const onClickWrapper = () => {
    // isOpen will not be updated by the bind before this callback is called.
    // This means if isOpen is true, then we are now collapsing the accordion.
    const eventType = isOpen ? "collapse_accordion" : "expand_accordion";
    onClick(eventType);
  };

</script>

<style>
  .fizz-accordion summary {
    padding: 0.5rem 3rem 0.5rem 1em;
    background-size: 1.5rem 1.5rem;
    background-position: right 1em center;
  }

  .active-border {
    border: 1px solid #008fbe;
    border-radius: 4px;
  }

</style>

{#if isMobile}
  <div class="fizz-surface fizz-inset-horizontal-16" data-testid="mobile-price-accordion">
    <details
      class="fizz-accordion fizz-bordered"
      bind:open={isOpen}
      class:active-border={isOpen}
      on:click={onClickWrapper}
      on:keypress={onClickWrapper}
      data-testid="mobile-price-accordion-details"
    >
      <summary>
        <Price {products} {total} {isMobile} />
      </summary>
      <slot />
    </details>
  </div>
{:else}
  <slot />
{/if}
